import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LOOKUP from 'constants/lookup';
// Basic Components
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';
const componentName = "GiftCardBalance";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-6">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                    defaultValue={new Date()}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6">
                <BranchMultiSelectAutoCompleteInput
                    name={`${componentName}Branches`}
                    fullWidth={true}
                    autoWidth={true}
                    label="Branches*"
                    floatingLabelText="Branches"
                    hintText="Branches"
                    style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                    defaultValues={props.branchOptions}
                    options={props.branchOptions}
                    fieldName={'Branches'}
                    updateStateImmediately
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
        </div>
    </CardSimple>
);
export default Header;